import Vue from 'vue'
import gql from 'graphql-tag'

import createGraphQLClient from '@utils/graphql'

let graphqlClient = null

export const state = {
    objects: {},
    serviceObjects: {}
}

export const getters = {}

export const mutations = {
    SET_BINS(state, objects) {
        let updatedObjects = {}
        for (let key in objects) {
            if (!objects[key].deleted_at) {
                // Remove the '__typename' field that gets added by GraphQL
                delete objects[key].__typename
                // Stage the update so we can just do one Vue.set
                updatedObjects[objects[key].id] = objects[key]
            } else if (state.objects.hasOwnProperty(objects[key].id)) {
                // Immediately delete the object
                Vue.delete(state.objects, objects[key].id)
            }
        }
        state.objects = {
            ...updatedObjects,
        }
    },
    SET_SERVICE_BINS(state, serviceObjects) {
      let updatedObjects = {}
      for (let key in serviceObjects) {
        if (!serviceObjects[key].deleted_at) {
          // Remove the '__typename' field that gets added by GraphQL
          delete serviceObjects[key].__typename
          // Stage the update so we can just do one Vue.set
          updatedObjects[serviceObjects[key].id] = serviceObjects[key]
        } else if (state.serviceObjects.hasOwnProperty(serviceObjects[key].id)) {
          // Immediately delete the object
          Vue.delete(state.serviceObjects, serviceObjects[key].id)
        }
      }
      state.serviceObjects = {
        ...updatedObjects,
      }
    },
    SET_BIN(state, objects) {
        state.currentBin = objects
    },
    SET_SERVICEBIN(state, objects) {
        state.currentServiceBin = objects
    },
}

export const actions = {
    init({ commit, rootState }) {
        // Initialise the GraphQL client
        graphqlClient = createGraphQLClient(rootState)
    },

    async getBins({ commit }) {
        try {
            await
                graphqlClient.query({
                    query: gql`
                  query getBins{
                    bins {
                      id
                      name
                      description
                      capacity
                      price
                      itemcode
                      created_at
                      updated_at
                      deleted_at
                    }
                  }
                `,
            }).then((response) => {
                commit('SET_BINS', response.data.bins)
                return response.data.bins
            })
        } catch (ex) {
            console.error(ex)
            throw ex
        }
    },

    async binById({ commit }, { id } = {}) {
        try {
            const response = await graphqlClient.query({
                query: gql`
                  query binById($Id: ID!) {
                    binById(id: $Id) {
                      id
                      name
                      description
                      capacity
                      price
                      created_at
                      updated_at
                      deleted_at
                    }
                  }
                `,
                variables:{ Id: id }
            })
            commit('SET_BIN', response.data.binById)
        } catch (ex) {
            console.error(ex)
            throw ex
        }
    },

    async createBin({ commit, dispatch }, {name, description, capacity, price, itemcode} = {}) {
        try {
            capacity = parseInt(capacity)
            price = 0; // as the client requested to have custom price per customer
            await graphqlClient.mutate({
                mutation: gql`
                    mutation createBin($Name: String $Description: String $Capacity: Int $Price: Int $Itemcode: String)  {
                      createBin(bin:{name: $Name description: $Description capacity: $Capacity price: $Price itemcode: $Itemcode}) {
                        id
                      }
                    }
                `,
                variables: { Name: name, Description: description, Capacity: capacity, Price: price, Itemcode: itemcode },
            })
            dispatch('getBins')
        } catch (ex) {
            console.error(ex)
            throw ex
        }
    },

    async deleteBin({ dispatch }, {id} = {}) {
        try {
            return await graphqlClient.mutate({
                mutation: gql`
                    mutation deleteBin($Id:Int!)  {
                      deleteBin(id: $Id) {
                        id
                      }
                    }
                    `,
                variables: { Id: id},
            }).then((response) => {
            // commit('SET_BINS', response.data.updateBin)
            dispatch('getBins')
          })
        } catch (ex) {
            console.error(ex)
            throw ex
        }
    },

    async updateBin({ commit, dispatch }, {id, name, description, capacity, price, itemcode} = {}) {
        try {
            capacity = parseInt(capacity)
            price = parseInt(price)
            id = parseInt(id)
            return await graphqlClient.mutate({
                mutation: gql`
                    mutation UpdateBin($Id: Int $Name: String $Description: String $Capacity: Int $Price: Int $Itemcode: String)  {
                      updateBin(id: $Id bin:{name: $Name description: $Description capacity: $Capacity price: $Price itemcode: $Itemcode}) {
                        id
                      }
                    }
                    `,
                variables: { Id: id, Name: name, Description: description, Capacity: capacity, Price: price, Itemcode: itemcode},
            }).then((response) => {
              // commit('SET_BINS', response.data.updateBin)
              dispatch('getBins')
            })
        } catch (ex) {
            console.error(ex)
            throw ex
        }
    },

    async addBinToService({ commit }, {chargePerLitre, chargePerTonne, serviceId, binId, price, binIdentifier, defaultPricing, issueDate, weeklyMaintenanceFee, padlocks, castors, weightAllowed, extraPrice} = {}) {
        try {
            // // console.log(weightAllowed)
            // // console.log(extraPrice)
            await graphqlClient.mutate({
                mutation: gql`
                    mutation addBinToService($chargePerTonne: Boolean $chargePerLitre: Boolean $ServiceId: ID! $BinId: ID! $Price: Int $BinIdentifier: String $DefaultPricing: Boolean $IssueDate: String $WeeklyMaintenanceFee: Int $Padlocks: Boolean $Castors: Boolean $WeightAllowed: Float $ExtraPrice: Int)  {
                      addBinToService(charge_per_tonne: $chargePerTonne charge_per_litre: $chargePerLitre service_id: $ServiceId bin_id:$BinId price: $Price bin_identifier: $BinIdentifier default_pricing: $DefaultPricing issue_date:$IssueDate weekly_maintenance_fee: $WeeklyMaintenanceFee padlocks: $Padlocks castors: $Castors weight_allowed: $WeightAllowed extra_price: $ExtraPrice) {
                        id
                        price
                        bin_id
                        bin{
                            id
                        }
                        weekly_maintenance_fee
                        issue_date
                        created_at
                        updated_at
                        deleted_at
                      }
                    }
                `,
                variables: { ServiceId: serviceId, BinId: binId, Price: price, BinIdentifier: binIdentifier, DefaultPricing: defaultPricing, IssueDate: issueDate, WeeklyMaintenanceFee:weeklyMaintenanceFee, Padlocks: padlocks, Castors: castors, WeightAllowed: weightAllowed, ExtraPrice: extraPrice, chargePerTonne: chargePerTonne, chargePerLitre: chargePerLitre },
            }).then((response) => {
              // console.log(response)
            })
        } catch (ex) {
            console.error(ex)
            throw ex
        }
    },

    async updateServiceBin({ commit, dispatch }, {chargePerLitre, chargePerTonne, binId, price, binIdentifier, defaultPricing, issueDate, weeklyMaintenanceFee, padlocks, castors, weightAllowed, extraPrice} = {}) {
        try {
            // let that = this
          // console.log(chargePerLitre)
          // console.log(chargePerTonne)
            await graphqlClient.mutate({
                mutation: gql`
                    mutation updateServiceBin (
                      $chargePerTonne: Boolean 
                      $chargePerLitre: Boolean 
                      $BinId: Int 
                      $Price: Int 
                      $BinIdentifier: String 
                      $DefaultPricing: Boolean 
                      $IssueDate: String 
                      $WeeklyMaintenanceFee: Int 
                      $Padlocks: Boolean 
                      $Castors: Boolean 
                      $WeightAllowed: Float 
                      $ExtraPrice: Int
                      )  {
                        updateServiceBin( 
                          id:$BinId 
                          price: $Price 
                          bin_identifier: $BinIdentifier 
                          default_pricing: $DefaultPricing 
                          issue_date:$IssueDate 
                          weekly_maintenance_fee: $WeeklyMaintenanceFee 
                          padlocks: $Padlocks 
                          castors: $Castors 
                          weight_allowed: $WeightAllowed 
                          extra_price: $ExtraPrice 
                          charge_per_tonne: $chargePerTonne 
                          charge_per_litre: $chargePerLitre
                         ) {
                          id,
                          extra_price
                        }                     
                    }
                `,
                variables: {
                  BinId: binId,
                  Price: price,
                  BinIdentifier: binIdentifier,
                  DefaultPricing: defaultPricing,
                  IssueDate: issueDate,
                  WeeklyMaintenanceFee: weeklyMaintenanceFee,
                  Padlocks: padlocks,
                  Castors: castors,
                  WeightAllowed: weightAllowed,
                  ExtraPrice: extraPrice,
                  chargePerTonne: chargePerTonne,
                  chargePerLitre: chargePerLitre
                },
            }).then((response) => {
              // console.log(response)
              commit('SET_BINS', response.data.updateBin)
              dispatch('getBins')
            })
        } catch (ex) {
            console.error(ex)
            throw ex
        }
    },

    async deleteServiceBin({ dispatch }, {id} = {}) {
      try {
        return await graphqlClient.mutate({
          mutation: gql`
            mutation deleteServiceBin($Id:Int!)  {
              deleteServiceBin(id: $Id) {
                id
              }
            }
            `,
          variables: { Id: id},
        }).then((response) => {
          dispatch('getBins')
        })
      } catch (ex) {
        console.error(ex)
        throw ex
      }
    },

    async serviceBinById({ commit }, { id } = {}) {
        try {
            const response = await graphqlClient.query({
                query: gql`
                  query serviceBinById($Id: ID!) {
                      serviceBinById(id: $Id) {
                        id
                        price
                        bin_id
                        bin {
                          id
                          description
                        }
                        issue_date
                        weekly_maintenance_fee
                        service{
                          id
                        }
                        castors
                        padlocks
                        created_at
                        updated_at
                        deleted_at
                      }
                    }
                `,
                variables:{ Id: id }
            })
            commit('SET_SERVICEBIN', response.data.serviceBinById)
        } catch (ex) {
            console.error(ex)
            throw ex
        }
    },

    async serviceBins({ commit }) {
      try {
        await graphqlClient.query({
          query: gql`
              query serviceBins{
                serviceBins {
                  id
                  price
                  padlocks
                  castors
                  completed
                  bin_id
                  bin{
                    id,
                    description,
                    capacity,
                    price
                  }
                  issue_date
                  weekly_maintenance_fee
                  service{
                    id,
                    service_title,
                    active,
                    description,
                    client_id{
                      id
                      client_name
                    }
                    service_type_id{
                      id,
                      name,
                      capacity
                    }
                    site{
                      address,
                      suburb,
                      state,
                      country,
                      postcode
                      phone 
                    }
                  }
                  created_at
                  updated_at
                  deleted_at
                }
              }
            `,
        }).then((response) => {
          // // console.log(response)
          commit('SET_SERVICE_BINS', response.data.serviceBins)
        })
      } catch (ex) {
        console.error(ex)
        throw ex
      }
    },

    async completeBin({ commit, dispatch }, { binId } = {}) {
      try {
        let status = true
        await graphqlClient.mutate({
          mutation: gql`
                mutation completeBin( $BinId: Int $Completed: Boolean)  {
                  updateServiceBin( id:$BinId completed: $Completed) {
                    id
                  }                     
                }
            `,
          variables: { BinId: binId, Completed: status },
        }).then((response) => {
          // console.log(response)
          // commit('SET_BINS', response.data.updateBin)
          dispatch('serviceBins')
        })
      } catch (ex) {
        console.error(ex)
        throw ex
      }
    },
}
